export default __webpack_public_path__ + "static/media/SpeakToExperienced_584x386.1869bbd7.png";